import { __rest, __assign } from '../../_virtual/_tslib.js';
import React__default, { useMemo } from 'react';
import { classNames } from '../../helpers/classnames.js';

/**
 * @description Skeleton
 * @param props - props
 * @param props.animated - animated or not animated skeleton. Default value: true
 * @param props.variant - variant of skeleton
 * @param props.className - custom class name
 * @param props.radius - border radius style
 * @param props.style - styles
 * @param props.height - height style
 * @param props.width - width style
 * @function
 */
var Skeleton = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'text' : _b, _c = _a.animated, animated = _c === void 0 ? true : _c, className = _a.className, radius = _a.radius, style = _a.style, height = _a.height, width = _a.width, margin = _a.margin, rest = __rest(_a, ["variant", "animated", "className", "radius", "style", "height", "width", "margin"]);
    /**
     * Memoized width. It set height like width, if it is square or circle variant and haven't width.
     */
    var localWidth = useMemo(function () { return ((variant === 'square' || variant === 'circle') && !width ? height : width); }, [height, variant, width]);
    /**
     * Memoized margins
     */
    var localMargins = useMemo(function () {
        if (typeof margin === 'object') {
            return {
                marginBottom: margin.bottom,
                marginLeft: margin.left,
                marginRight: margin.right,
                marginTop: margin.top
            };
        }
        return {
            margin: margin
        };
    }, [margin]);
    /**
     * Memoized class names. Depends on variant, animation and custom class name.
     */
    var classes = useMemo(function () {
        return classNames('dsb_skeleton', "dsb_skeleton__".concat(variant), { 'dsb_skeleton__no-animation': !animated }, className);
    }, [animated, className, variant]);
    /**
     * Memoized styles. It adds a borderRadius, height and width, if it has they.
     */
    var localStyle = useMemo(function () { return (__assign(__assign(__assign({}, style), localMargins), { borderRadius: radius, height: height, width: localWidth })); }, [style, localMargins, radius, height, localWidth]);
    return React__default.createElement("div", __assign({ "data-testid": "Skeleton", className: classes, style: localStyle }, rest));
};

export { Skeleton };
